/**
 * Base API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundstueckArt } from './grundstueckArt';
import { IntercapiSprache } from './intercapiSprache';
import { CapitastraSprache } from './capitastraSprache';
import { JsonParameter } from './jsonParameter';


export interface ParameterConfigResponse { 
    grundstueckArt?: GrundstueckArt;
    grundstueckArtEnum?: ParameterConfigResponse.GrundstueckArtEnumEnum;
    startseiteTextParameter?: ParameterConfigResponse.StartseiteTextParameterEnum;
    jsonParameter?: JsonParameter;
    intercapiSprache?: IntercapiSprache;
    capitastraSprache?: CapitastraSprache;
    parameters?: { [key: string]: object; };
}
export namespace ParameterConfigResponse {
    export type GrundstueckArtEnumEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR' | 'SDR_FLAECHENMAESSIG_NICHT_AUSGESCHIEDEN';
    export const GrundstueckArtEnumEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnumEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnumEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnumEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnumEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnumEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnumEnum,
        SDR: 'SDR' as GrundstueckArtEnumEnum,
        SDR_FLAECHENMAESSIG_NICHT_AUSGESCHIEDEN: 'SDR_FLAECHENMAESSIG_NICHT_AUSGESCHIEDEN' as GrundstueckArtEnumEnum
    };
    export type StartseiteTextParameterEnum = 'STARTSEITE_TEXT_INTERCAPI_DEUTSCH_EDITIEREN' | 'STARTSEITE_TEXT_INTERCAPI_FRANZOESISCH_EDITIEREN' | 'STARTSEITE_TEXT_INTERCAPI_ITALIENISCH_EDITIEREN' | 'STARTSEITE_TEXT_INTERCAPI_PUBLIC_DEUTSCH_EDITIEREN' | 'STARTSEITE_TEXT_INTERCAPI_PUBLIC_FRANZOESISCH_EDITIEREN';
    export const StartseiteTextParameterEnum = {
        STARTSEITE_TEXT_INTERCAPI_DEUTSCH_EDITIEREN: 'STARTSEITE_TEXT_INTERCAPI_DEUTSCH_EDITIEREN' as StartseiteTextParameterEnum,
        STARTSEITE_TEXT_INTERCAPI_FRANZOESISCH_EDITIEREN: 'STARTSEITE_TEXT_INTERCAPI_FRANZOESISCH_EDITIEREN' as StartseiteTextParameterEnum,
        STARTSEITE_TEXT_INTERCAPI_ITALIENISCH_EDITIEREN: 'STARTSEITE_TEXT_INTERCAPI_ITALIENISCH_EDITIEREN' as StartseiteTextParameterEnum,
        STARTSEITE_TEXT_INTERCAPI_PUBLIC_DEUTSCH_EDITIEREN: 'STARTSEITE_TEXT_INTERCAPI_PUBLIC_DEUTSCH_EDITIEREN' as StartseiteTextParameterEnum,
        STARTSEITE_TEXT_INTERCAPI_PUBLIC_FRANZOESISCH_EDITIEREN: 'STARTSEITE_TEXT_INTERCAPI_PUBLIC_FRANZOESISCH_EDITIEREN' as StartseiteTextParameterEnum
    };
}


